// extracted by mini-css-extract-plugin
export var heading = "HubspotModal-module--heading--70962";
export var wrapper = "HubspotModal-module--wrapper--98d4d";